customElements.get("load-more") || customElements.define("load-more", class extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("a"), this.buttonText = this.button.textContent, 
    this.section = this.dataset.section || "", this.selectors = [ "[data-grid]", "[data-pagination-next]", "[data-pagination-previous]" ], 
    this.swat = null, this.setupSwymIntegration();
  }
  setupSwymIntegration() {
    if (!0 !== Shopify.MBF.wishlistEnabled) return void console.log("LoadMore: Wishlist functionality is disabled, skipping Swym integration");
    const t = Date.now(), e = () => {
      window.Swym && "function" == typeof window.Swym.registerComponent ? window.Swym.registerComponent(t => {
        this.swat = t, this.initializeSwymButtons();
      }) : Date.now() - t < 3e4 ? setTimeout(e, 100) : console.warn("Swym utility did not become available within 30 seconds for load-more component");
    };
    e();
  }
  initializeSwymButtons() {
    if (this.swat) {
      const t = `#shopify-section-${this.section} [data-grid]`;
      this.swat.initializeActionButtons(t);
    }
  }
  connectedCallback() {
    this.button?.addEventListener("click", this.loadMore.bind(this));
  }
  loadMore(t) {
    t.preventDefault(), t.stopPropagation(), this.classList.add("opacity-50", "cursor-wait"), 
    window.strings.loading && (this.button.textContent = window.strings.loading);
    const e = t.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend", i = document.querySelector(`#shopify-section-${this.section}`) || document, n = new URL(t.target.href), o = new URLSearchParams(n.search);
    o.set("section_id", this.section), fetch(`${n.pathname}?${o.toString()}`).then(t => t.text()).then(n => {
      const s = (new DOMParser).parseFromString(n, "text/html");
      [ `[data-load-${t.target.dataset.mode || "next"}]`, ...this.selectors ].forEach(n => {
        const a = i.querySelector(n);
        if (a) {
          const t = s.querySelector(n);
          t ? n.toLowerCase().includes("grid") ? a.insertAdjacentHTML(e, t.innerHTML) : a.innerHTML = t.innerHTML : a.parentNode.removeChild(a);
        }
        history.pushState(Object.fromEntries(o), "", t.target.href), this.button.textContent = this.buttonText, 
        this.initializeSwymButtons();
      });
    }).catch(e => {
      console.warn(e), location.href = t.target.href;
    }).finally(() => {
      this.classList.remove("opacity-50", "cursor-wait");
    });
  }
});